import { MetaPartnerApiClient } from '@fourthwall/services/dist/MetaPartnerApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useMetaCatalogMutation = createMutationHook(MetaPartnerApiClient.updateMetaCatalog, {
  mutationKey: ['updateMetaCatalog'],
})
